// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DislikeTwoToneSvg from "@fishx/icons-svg/es/asn/DislikeTwoTone";
import FishxIcon from '../components/FishxIcon';

var DislikeTwoTone = function DislikeTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DislikeTwoToneSvg
  }));
};

DislikeTwoTone.displayName = 'DislikeTwoTone';
export default React.forwardRef(DislikeTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DislikeTwoTone.js
// module id = 2436
// module chunks = 0